<ng-container [ngSwitch]="saveContactState$ | async">
  <div nxModalContent class="contact-agent__wrapper">
    <div *ngSwitchCase="apiStates.success" class="contact-agent contact-agent--success">
      <div class="contact-agent--col">
        <div class="contact-agent--icon nx-margin-bottom-3m">
          <qbe-illustration name="sent" />
        </div>
        <h2 nxHeadline="subsection-large" class="nx-margin-bottom-s">
          {{ 'modals.contact-agent.submitted.title' | translate }}
        </h2>
        <p nxCopytext="normal" class="nx-margin-bottom-3m">
          {{ 'modals.contact-agent.submitted.description' | translate }}
        </p>
        <a nxButton href="https://allianz.pl">
          {{ 'modals.contact-agent.submitted.button' | translate }}
        </a>
      </div>
    </div>
    <div *ngSwitchDefault nxRow class="contact-agent">
      <div nxCol="12,12,6,6" class="contact-agent--col contact-agent--title">
        <h2 nxHeadline="subsection-large" class="nx-margin-bottom-s">
          {{ (contentType === 'winterSportsHiRisk' ? 'modals.contact-agent.winterSportsHiRisk.title' : 'modals.contact-agent.title') | translate }}
        </h2>
        <p nxCopytext="normal" [innerHTML]="(contentType === 'winterSportsHiRisk' ? 'modals.contact-agent.winterSportsHiRisk.description' : 'modals.contact-agent.description') | translate | markdown"></p>
        <div class="contact-agent--illustration">
          <app-illustration-absolute name="womanWithLaptopTalkingOnThePhoneWithPlant" [maxWidth]="316" width="100%" />
        </div>
      </div>
      <div nxCol="12,12,6,6" class="contact-agent--col contact-agent--content">
        <form [formGroup]="formGroup">
          <app-dynamic-input
            [formGroup]="formGroup"
            name="firstName"
            inputType="text"
            label="modals.contact-agent.form.firstName.label"
          ></app-dynamic-input>
          <app-dynamic-input
            [formGroup]="formGroup"
            name="lastName"
            inputType="text"
            label="modals.contact-agent.form.lastName.label"
          ></app-dynamic-input>
          <app-dynamic-input
            [formGroup]="formGroup"
            name="phoneNumber"
            inputType="phoneNumber"
            label="modals.contact-agent.form.phoneNumber.label"
          ></app-dynamic-input>
          <app-dynamic-input
            [formGroup]="formGroup"
            name="immediateContact"
            inputType="radio"
            [options]="immediateContactOptions"
          ></app-dynamic-input>
          <app-dynamic-input
            *ngIf="formGroup.value.immediateContact === 'planned'"
            [formGroup]="formGroup"
            name="date"
            inputType="date"
            label="modals.contact-agent.form.date.label"
            [minDate]="minDate"
            [noWeekends]="true"
          ></app-dynamic-input>
          <app-dynamic-input
            *ngIf="formGroup.value.immediateContact === 'planned'"
            [formGroup]="formGroup"
            name="time"
            inputType="select"
            label="modals.contact-agent.form.time.label"
            [options]="(filteredTimeOptions$ | async) || timeOptions"
            [optionFilter]="false"
          ></app-dynamic-input>
          <app-error *ngIf="(saveContactState$ | async) === apiStates.error" [appError]="saveContactError$ | async" class="nx-margin-top-m" />
          <button nxButton type="submit" (click)="handleSubmit()" [disabled]="formGroup.invalid" class="nx-margin-top-m">
            {{ 'modals.contact-agent.button' | translate }}
          </button>
        </form>
      </div>
    </div>
  </div>
</ng-container>
